import {
  AdminSummaryQuery,
  AdminSummaryResponse,
  AdminSummaryResponseSchema,
  AdminTimeseriesResponse,
  AdminTimeseriesResponseSchema,
} from "@codway-dev/shared";
import { AuthService } from "./auth.service";

const API_BASE_URL = "/api";

function buildAnalyticsQuery(params: AdminSummaryQuery): string {
  return new URLSearchParams({
    date_from: params.date_from,
    date_to: params.date_to,
    ...(params.form_id ? { form_id: params.form_id } : {}),
    ...(params.country_id ? { country_id: params.country_id } : {}),
  }).toString();
}

async function parseJsonResponse<T>(
  response: Response,
  schema: { parse: (data: unknown) => T },
  label: string
): Promise<T> {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message =
      typeof data === "object" &&
      data !== null &&
      "error" in data &&
      typeof (data as { error: unknown }).error === "string"
        ? (data as { error: string }).error
        : `${label} failed (${response.status})`;
    throw new Error(message);
  }
  return schema.parse(data);
}

export const AnalyticsService = {
  getSummary: async (
    query: AdminSummaryQuery,
    signal?: AbortSignal
  ): Promise<AdminSummaryResponse> => {
    const response = await AuthService.fetchAPI(
      `${API_BASE_URL}/admin/analytics/summary?${buildAnalyticsQuery(query)}`,
      { signal }
    );
    return parseJsonResponse(
      response,
      AdminSummaryResponseSchema,
      "Analytics summary"
    );
  },

  getTimeseries: async (
    query: AdminSummaryQuery,
    signal?: AbortSignal
  ): Promise<AdminTimeseriesResponse> => {
    const response = await AuthService.fetchAPI(
      `${API_BASE_URL}/admin/analytics/timeseries?${buildAnalyticsQuery(query)}`,
      { signal }
    );
    return parseJsonResponse(
      response,
      AdminTimeseriesResponseSchema,
      "Analytics timeseries"
    );
  },
};
